import React from "react";
import Layout from "./../layout";
import { URLS } from "../../_config";
import Breadcrumbs from "../../components/breadcrumbs/Breadcrumbs";
import ToggleSwitch2 from "../../components/ToggleSwitch2";

import { Tab, Tabs, Nav, Card, Form, Button, Row, Col } from "react-bootstrap";
const handleToggle2 = (state: boolean) => {
  console.log("Toggle state:", state);
};
const EmployeeReview: React.FC = () => {
  return (
    <Layout>
      <div data-aos="fade-up" data-aos-duration="1000">
        <Breadcrumbs
          title="Employee Review"
          breadcrumbs={{
            Home: URLS.PROFILE,
            "Employee Review": "",
          }}
        />

<div className="">
                    <div className="container-fluid">

                      
                        
                        

                        <div className="row mb-4">
                            <div className="col-sm-4">
                                <div className="details-info-block d-flex">
                                    <div className="details-info-pic">
                                        <img src="assets/images/lenda/01.png"/>
                                    </div>
                                    <div className="details-info-content">
                                        <div className="d-flex align-items-center justify-content-end fb-like mb-0">
                                            <p className="d-flex align-items-center">
                                                <img src="assets/images/icons/facebook-like.svg"/>
                                                814
                                            </p>
                                            <p className="d-flex align-items-center">
                                                <img src="assets/images/icons/facebook-dislike.svg"/>
                                                84
                                            </p>
                                        </div>
                                        <p className="d-flex gap-1 align-items-center mb-0"><img src="assets/images/icons/website-icon.svg" /> <a href="#">http://www.uwm.com</a></p>
                                        <h3>Terrence Mack <span>(Account Executive)</span></h3>
                                        <p>Faster Easier Cheaper Mortgages</p>
                                        <div className="d-flex gap-2 mb-2">
                                            <a href="#" className="add-rating-btn">Add Rating +</a>
                                            <a href="#" className="round-btn">
                                                <img src="assets/images/icons/note.svg" />
                                            </a>
                                            <a href="#" className="round-btn">
                                                <img src="assets/images/icons/share.svg" />
                                            </a>
                                            <a href="#" className="round-btn">
                                                <img src="assets/images/icons/copy.svg" />
                                            </a>
                                        </div>
                                        <p className="d-flex gap-1 align-items-center mb-1"><img src="assets/images/review/New Letter.png" /> <a href="mailto:tmack@uwm.com"> tmack@uwm.com</a></p>
                                        <p className="d-flex gap-1 align-items-center mb-0"><img src="assets/images/review/Phone Ringing.png" />  <a href="mailto:tmack@uwm.com">800-981-8898 ext 61959</a></p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-sm-4">
                                <div className="rating-block">
                                    <div className="d-flex justify-content-between align-items-center mb-3">
                                        <h3>Rating’s</h3>
                                        <h5>4.9/5</h5>
                                    </div>
                                    <div className="rating-row d-flex align-items-center">
                                        <div className="d-flex gap-1">
                                            <span className="rating-no">5</span>
                                            <img src="assets/images/icons/rating-star.svg" />
                                        </div>
                                        <div className="rating-line flex-grow-1"></div>
                                        <span>219</span>
                                    </div>
                                    <div className="rating-row d-flex align-items-center">
                                        <div className="d-flex gap-1">
                                            <span className="rating-no">4</span>
                                            <img src="assets/images/icons/rating-star.svg" />
                                        </div>
                                        <div className="rating-line flex-grow-1"></div>
                                        <span>1</span>
                                    </div>
                                    <div className="rating-row d-flex align-items-center">
                                        <div className="d-flex gap-1">
                                            <span className="rating-no">3</span>
                                            <img src="assets/images/icons/rating-star.svg" />
                                        </div>
                                        <div className="rating-line flex-grow-1"></div>
                                        <span>5</span>
                                    </div>
                                    <div className="rating-row d-flex align-items-center">
                                        <div className="d-flex gap-1">
                                            <span className="rating-no">2</span>
                                            <img src="assets/images/icons/rating-star.svg" />
                                        </div>
                                        <div className="rating-line flex-grow-1"></div>
                                        <span>8</span>
                                    </div>
                                    <div className="rating-row d-flex align-items-center">
                                        <div className="d-flex gap-1">
                                            <span className="rating-no">1</span>
                                            <img src="assets/images/icons/rating-star.svg" />
                                        </div>
                                        <div className="rating-line flex-grow-1"></div>
                                        <span>6</span>
                                    </div>
                                </div>
                            </div>
                            <div className="col-sm-4">
                                <div className="details-brief-block">
                                    <div className="details-brief-row d-flex justify-content-between align-items-center">
                                        <p>Average CTC :</p>
                                        <p>12.97 day(s)</p>
                                    </div>
                                    <div className="details-brief-row d-flex justify-content-between align-items-center">
                                        <p>Revenue (BPS) :</p>
                                        <p>275</p>
                                    </div>
                                    <div className="details-brief-row d-flex justify-content-between align-items-center">
                                        <p>Max & Comp :</p>
                                        <p>30.000</p>
                                    </div>
                                    <div className="details-brief-row d-flex justify-content-between align-items-center">
                                        <p>VA ID :</p>
                                        <p>VA Sponsor ID 7460480000</p>
                                    </div>
                                    <div className="details-brief-row d-flex justify-content-between align-items-center">
                                        <p>FHA ID :</p>
                                        <p>FHA Sponsor ID 7184500000</p>
                                    </div>
                                    <div className="details-brief-row d-flex justify-content-between align-items-center">
                                        <p>Early Pay Off :</p>
                                        <p>180</p>
                                    </div>
                                    <div className="details-brief-row d-flex justify-content-between align-items-center">
                                        <p>Loan Sifter :</p>
                                        <img src="assets/images/icons/green-check.svg" />
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="card">
                            <div className="card-body">
                                <h3 className="review_title">Reviews</h3>
                                <div className="row">
                                    <div className="col-lg-4 col-md-4">
                                        <div className="form-group">
                                            <label htmlFor="">Loan Type</label>
                                            <select id="formrow-inputState" className="form-control">
                                                <option>Select</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div className="col-lg-4 col-md-4">
                                        <div className="form-group">
                                            <label htmlFor="formrow-firstname-input">Sort by</label>
                                            <div className="fld-icon-end">
                                                <input type="text" className="form-control" id="formrow-firstname-input" value=""/>
                                                <i className="input_rgticon username_icon"></i>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-4 col-md-4">
                                        <div className="form-group">
                                            
                                            <div className="fld-icon-end">
                                                <input type="text" className="form-control review_search" id="formrow-firstname-input" value="" placeholder="Search"/>
                                                <i className="input_rgticon searchreview_icon"></i>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="processor_listing review_listing">
                                    <ul>
                                        
                                        <li>
                                            <div className="processor_listtop">
                                                    <div className="hour_ago">CTC : 1 day(s)</div>
                                                    <div className="like_dislike">
                                                        <a href="javascript:void(0);"><img src="assets/images/processor/like.svg"/></a>
                                                        <span className="like_txt">30</span>
                                                        <a href="javascript:void(0);"><img src="assets/images/processor/dislike.svg"/></a>
                                                        <span className="dislike_txt">0</span>
                                                    </div>
                                            </div>
                                            <div className="processor_lisbottom">
                                                    <div className="rocessor_listimgctrl">
                                                        <div className="rocessor_listimg">
                                                            <img src="assets/images/processor/image_01.jpg"/>
                                                        </div>
                                                        
                                                    </div>
                                                    <div className="rocessor_listright">
                                                        <h4>By <span>Jiji Thomas</span></h4>
                                                        <div className="rating"><img src="assets/images/processor/rating.png"/> (4.5/10)</div>
                                                        
                                                    </div>
                                                    
                                            </div>
                                            <div className="reviewdetail_txt">
                                                <h5>AE</h5>
                                                <p>
                                                    One of the best AE for UWM. Very knowledgeable and always have given me the best information.Even when it is directing me to another lender.
                                                </p>
                                            </div>
                                            <div className="time_ago">7 months ago | Wed, Jun 12, 2024 04:03</div>
                                            <a href="#" className="submit_file d-inline-flex px-3">Conventional</a>
                                        </li>
                                        <li>
                                            <div className="processor_listtop">
                                                    <div className="hour_ago">CTC : 1 day(s)</div>
                                                    <div className="like_dislike">
                                                        <a href="javascript:void(0);"><img src="assets/images/processor/like.svg"/></a>
                                                        <span className="like_txt">30</span>
                                                        <a href="javascript:void(0);"><img src="assets/images/processor/dislike.svg"/></a>
                                                        <span className="dislike_txt">0</span>
                                                    </div>
                                            </div>
                                            <div className="processor_lisbottom">
                                                    <div className="rocessor_listimgctrl">
                                                        <div className="rocessor_listimg">
                                                            <img src="assets/images/processor/image_01.jpg"/>
                                                        </div>
                                                        
                                                    </div>
                                                    <div className="rocessor_listright">
                                                        <h4>By <span>Leslie Perkinson</span></h4>
                                                        <div className="rating"><img src="assets/images/processor/rating.png"/> (4.5/10)</div>
                                                        
                                                    </div>
                                                    
                                            </div>
                                            <div className="reviewdetail_txt">
                                                <h5>AE</h5>
                                                <p>
                                                    One of the best AE for UWM. Very knowledgeable and always have given me the best information.Even when it is directing me to another lender.
                                                </p>
                                            </div>
                                            <div className="time_ago">7 months ago | Wed, Jun 12, 2024 04:03</div>
                                            <a href="#" className="submit_file d-inline-flex px-3">Refinance Rate/Term</a>
                                        </li>
                                        <li>
                                            <div className="processor_listtop">
                                                    <div className="hour_ago">CTC : 1 day(s)</div>
                                                    <div className="like_dislike">
                                                        <a href="javascript:void(0);"><img src="assets/images/processor/like.svg"/></a>
                                                        <span className="like_txt">30</span>
                                                        <a href="javascript:void(0);"><img src="assets/images/processor/dislike.svg"/></a>
                                                        <span className="dislike_txt">0</span>
                                                    </div>
                                            </div>
                                            <div className="processor_lisbottom">
                                                    <div className="rocessor_listimgctrl">
                                                        <div className="rocessor_listimg">
                                                            <img src="assets/images/processor/image_01.jpg"/>
                                                        </div>
                                                        
                                                    </div>
                                                    <div className="rocessor_listright">
                                                        <h4>By <span>Bridgette Tucker</span></h4>
                                                        <div className="rating"><img src="assets/images/processor/rating.png"/> (4.5/10)</div>
                                                        
                                                    </div>
                                                    
                                            </div>
                                            <div className="reviewdetail_txt">
                                                <h5>AE</h5>
                                                <p>
                                                    One of the best AE for UWM. Very knowledgeable and always have given me the best information.Even when it is directing me to another lender.
                                                </p>
                                            </div>
                                            <div className="time_ago">7 months ago | Wed, Jun 12, 2024 04:03</div>
                                            <a href="#" className="submit_file d-inline-flex px-3">Conventional</a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                       
                      


                    </div> 
                </div>
      </div>
    </Layout>
  );
};

export default EmployeeReview;
